import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import userService from "../../services/userService";

export const getAutoPaymentPackages = createAsyncThunk(
    "subscription/getAutoPaymentPackages",
    async () => {
        const response = await userService.getPackagesForAutoPayments();
        return response.data;
    }
);

export const cancelAutopaymentSubscription = createAsyncThunk(
    "subscription/cancelAutopaymentSubscription",
    async ({ itemId }) => {
        const response = await userService.cancelAutopaymentSubscription(itemId);
        return response.data;
    }
);

export const createAutopaymentSubscription = createAsyncThunk(
    "subscription/createAutopaymentSubscription",
    async ({ formData }) => {
        const response = await userService.createAutopaymentSubscription(formData);
        return response.data;
    }
);

const initialState = {
    loading: false,
    packages: ""
};

const subscriptionSlice = createSlice({
    name: "subscription",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAutoPaymentPackages.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(getAutoPaymentPackages.fulfilled, (state, action) => {
            state.loading = false;
            state.packages = action.payload.packages;
        });
        builder.addCase(getAutoPaymentPackages.rejected, (state, action) => {
            state.loading = false;
        });
        builder.addCase(cancelAutopaymentSubscription.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(cancelAutopaymentSubscription.fulfilled, (state, action) => {
            state.loading = false;
            state.packages = action.payload.packages;
        });
        builder.addCase(cancelAutopaymentSubscription.rejected, (state, action) => {
            state.loading = false;
        });
        builder.addCase(createAutopaymentSubscription.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(createAutopaymentSubscription.fulfilled, (state, action) => {
            state.loading = false;
            state.packages = action.payload.packages;
        });
        builder.addCase(createAutopaymentSubscription.rejected, (state, action) => {
            state.loading = false;
        });
    }
});

export default subscriptionSlice.reducer;